module.exports = __webpack_public_path__ + "static/chat-buble-row-270ea12aa18ebbd2557f1b4465276138.png";